import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import AbunTable from "../../components/AbunTable/AbunTable";

export interface WebPage {
    url: string;
    title: string;
    summary: string;
    lastScanned: string;
}

interface WebsiteScanningProps {
    isCrawling: boolean
    websiteDomain: string,
    websiteScanData: Array<WebPage>
}

export default function WebsiteScanning(props: WebsiteScanningProps) {
    // ---------------------- NON STATE CONSTANTS ----------------------
    const pageSizes = [15, 25, 50, 100];

    // ---------------------- STATES ----------------------
    const [showWebsiteScanData, setShowWebsiteScanData] = useState(false);

    // ---------------------- TABLE COLUMN DEFS ----------------------
    const columnHelper = createColumnHelper<WebPage>();
    const columnDefs: ColumnDef<any, any>[] = [
        columnHelper.accessor((row: WebPage) => row.url, {
            id: 'url',
            header: "URL",
            cell: props => <NavLink to={props.getValue()} target="_blank">{props.getValue()}</NavLink>,
            enableGlobalFilter: true,
            meta: { align: 'left' }
        }),
        columnHelper.accessor((row: WebPage) => row.summary, {
            id: 'summary',
            header: "Summary",
            cell: props => (
                <div className="website-scanning-summary-cell">
                    <div className="summary-content">{props.getValue()}</div>
                    <div className="summary-tooltip">{props.getValue()}</div>
                </div>
            ),
            enableGlobalFilter: true,
            meta: { align: 'left' }
        }),
        columnHelper.accessor((row: WebPage) => row.lastScanned, {
            id: 'lastScanned',
            header: "Last Scanned",
            cell: info => info.getValue(),
            enableGlobalFilter: true,
            meta: { align: 'center' }
        }),
    ];

    // ============================================================
    // --------------------- MAIN RENDER CODE ---------------------
    // ============================================================
    if (props.isCrawling) {
        return (
            <div className="analysis-progress-container">
                <div className="analysis-card">
                    <h1 className="analysis-title">Website Analysis in Progress</h1>
                </div>
            </div>
        );
    }
    return (
        <>
            <div className={"card w-100 mt-4"}>
                <header
                    className="card-header is-clickable"
                    onClick={() => setShowWebsiteScanData(!showWebsiteScanData)}
                >
                    <p className="card-header-title">
                        Internal Links Manager ({props.websiteDomain})
                    </p>
                    <span className="card-header-icon">
                        <FontAwesomeIcon icon={showWebsiteScanData ? faChevronDown : faChevronRight} />
                    </span>
                </header>
                {showWebsiteScanData && (
                    <div className="tab-content">
                        {/* <div className="card"> */}
                        <div className="card-content">
                            <div className="mb-4">
                                <h1 className="has-text-centered" style={{ fontSize: "2em", fontWeight: "normal", width: "100%" }}>
                                    Internal Links Manager ({props.websiteDomain})
                                </h1>
                            </div>
                            <AbunTable
                                tableContentName={"Internal Links"}
                                tableData={props.websiteScanData}
                                columnDefs={columnDefs}
                                pageSizes={pageSizes}
                                initialPageSize={pageSizes[0]}
                                noDataText={"No internal links data available."}
                                searchboxPlaceholderText={"Search internal links..."}
                            />
                        </div>
                        {/* </div> */}
                    </div>
                )}
            </div>
        </>
    );
}